// Public API for the Account entity — single import surface.
//
// Layout:
//   - `endpoints.ts`  — 1:1 Withings webservice wrappers (get, getUsersList,
//                        sessionIsVerified, sessionExtend)
//   - `actions/`      — multi-endpoint orchestrators (fetchCurrentUser)
//   - `index.ts`      — aggregator (this file)

import * as endpoints from './endpoints';
import { fetchCurrentUser } from './actions/fetchCurrentUser';

const AccountService = {
  ...endpoints,
  fetchCurrentUser,
};

export default AccountService;
export type { AccountData, UserData } from './endpoints';
export type { CurrentUserData } from './actions/fetchCurrentUser';
export { WsError } from '@/lib/wiservice';
